import { cardBrandMap } from '@frontend/payments-card-brand';

export interface BrandDisplay {
  label: string;
  icon?: string;
}

/** Card brand label/logo. Unknown brands keep a neutral label instead of defaulting to Visa (gap G1). */
export const getCardBrandDisplay = (brand: string, fallbackLabel: string): BrandDisplay => {
  const info = brand ? cardBrandMap[brand.toUpperCase()] : undefined;
  if (!info?.label) return { label: fallbackLabel };
  return { label: info.label, icon: info.icon };
};

export const getAchIcon = () => cardBrandMap.ACH?.icon;
